import script from "./TableRowSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRowSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TableRowSkeleton.vue?vue&type=style&index=0&id=08c9dc06&lang=css"

const __exports__ = script;

export default __exports__